import { Vue, Component, Prop } from 'vue-property-decorator'
import PortionDetailedIcon from '@/assets/images/svg/portion-detailed-icon.vue'
import CommonPortionStatusBadge from '@/components/common/CommonPortionStatusBadge.vue'

@Component({
    components: {
        PortionDetailedIcon,
        CommonPortionStatusBadge
    }
})

export default class GrossingTouchPortionCard extends Vue {
    @Prop(Object) readonly portionInfo!: object
}
